import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./CheckboxItem.module.css";
import checkmark from "./checkmark2.png";

/**
 * An item that changes styling when checkbox is checked.
 */
export function CheckboxItem({ label, checked, onChange, disabled = false }) {
  return (
    <div
      className={classNames(
        styles.container,
        checked && styles.checkedContainer
      )}
    >
      <div
        className={classNames(
          styles.checkboxContainer,
          checked && styles.checkedCheckBox
        )}
        onClick={disabled ? null : onChange}
      >
        {checked && (
          <div className={styles.checkMarkContainer}>
            <img src={checkmark} className={styles.checkMark} />
          </div>
        )}
      </div>

      <div>{label}</div>
    </div>
  );
}

CheckboxItem.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};
